import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { translate } from '@ngneat/transloco';
import { MessageService, SelectItemGroup } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Paginate } from 'src/app/shared/models/paginate.model';
import { User } from 'src/app/shared/models/user/user.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';
import { UntypedFormGroup, Validators, FormGroup, FormBuilder, FormArray, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FranchiseService, FranchiseServiceCourseIndex } from '../../services/franchise.service';
import { FranchiseCourseDesign } from '../../models/franchise-course-design.model';
import { FranchiseCourse } from '../../models/franchise-course.model';
import { Franchise } from '../../models/franchise.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { UploadComponentQueueType } from 'src/app/groups/module/module.component';
import { UploadModel } from '../../models/upload.model';
import { CourseDesign } from '../../models/course-design.model';
import { ApiValidation } from '../../services/api-validation.service';
import { ModalItemsChooseComponentItem } from '../modal-items-chooser/modal-items-chooser.component';
import { FranchisePreference } from '../../models/franchise-preference.model';
import { UploadComponentActionName } from '../upload/upload.component';
import { FranchiseCourseSection } from '../../models/franchise-course-section.model';
import { FranchiseCourseFormField } from '../../models/franchise-course-form-field.model';
import { FranchiseCourseFormFieldOption } from '../../models/franchise-course-form-field-option.model';

export interface UploadComponentQueue {
    index: number;
    file: File;
    chunks: number;
    chunk: number;
    error: any;
    response: {data: UploadModel};
};

export enum SectionType {
    Header = 'header',
    Intro = 'intro',
    FAQ = 'faq',
    Program = 'program',
    Form = 'form',
    Advantages = 'advantages',
    Hashtags = 'hashtags',
    Certificate = 'certificate',
    Teacher ='teacher',
    Feedback = 'feedback',
    Skill = 'skill',
    Timeline = 'timeline',
    Price = 'price',
    Icons = 'icons',
    Card = 'card',
    Banner = 'banner',
    Footer = 'footer',
};

@Component({
    selector: 'page-franchise-course-edit',
    templateUrl: './page-franchise-course-edit.component.html',
    styleUrls: ['./page-franchise-course-edit.component.scss'],
})
export class PageFranchiseCourseEditComponent implements OnInit, OnDestroy {
    protected readonly PAGINATION_LIMIT: number = environment.pagination.default;
    protected readonly CACHING_MAX_TIME: number = environment.caching.default;

    protected innerLoadingQueue: number = 0;
    protected listSubscription?: Subscription;
    protected subscriptions: Subscription[] = [];

    readonly SECTION_NAMES: {[key in SectionType|string]: string} = {
        header: translate('Хедър'),
        intro: translate('Въведение'),
        faq: translate('Чести въпроси'),
        program: translate('Програма'),
        form: translate('Формуляр'),
        advantages: translate('Предимства'),
        hashtags: translate('Хаштагове'),
        certificate: translate('Сертификати'),
        teacher: translate('Преподаватели'),
        feedback: translate('Мнения на курсисти'),
        skill: translate('Умения'),
        footer: translate('Футър'),
        timeline: translate('Хронология'),
        price: translate('Цена'),
        icons: translate('Икони'),
        card: translate('Карти'),
        banner: translate('Банер'),
    };

    franchiseId: string|null = null;
    franchise: Franchise|null = null;

    courseId: string|null = null;
    course: FranchiseCourse|null = null;

    loading: boolean = false;
    form: UntypedFormGroup|null = null;
    errors: any = {};

    message: string = '';
    messageType: ('error'|'success') = 'error';

    optionsDesign: FranchiseCourseDesign[] = [];
    optionsCategory: Array<{value: string, label: string}> = [
        {value: '', label: '< ' + translate('По подразбиране') + ' >'},
        {value: "software", label: translate('Софтуерно инженерство')},
        {value: "marketing", label: translate('Маркетинг')},
        {value: "design", label: translate('Дизайн')},
        {value: "kids", label: translate('Детски програми')},
        {value: "ai", label: translate('Изкуствен интелект')},
    ];
    optionsSidebar: SelectItemGroup[] = [{
        label: ' ',
        items: [{
            label: translate('Без сертификат от академията'),
            value: 'without_exam'
        }, {
            label: translate('Без удостоверение от МОН'),
            value: 'without_certificate'
        }, {
            label: translate('Без видео записи от лекции'),
            value: 'without_video'
        }]
    }];

    user: User = new User;
    design: CourseDesign|null = null;
    selectedSectionIndex: number | null = null;
    selectedSection: number | null = null;
    selectedItemIndex: number | null = null;
    photo: any = null;

    sectionTypeOptions: any = {};
    showCopySectionsDialog: boolean = false;
    franchiseCourses?: Paginate<FranchiseCourse>|null;
    franchiseCoursesList: ModalItemsChooseComponentItem[] = [];
    franchiseCoursesFilter: FranchiseServiceCourseIndex = {
        page: 1,
        limit: this.PAGINATION_LIMIT,
        q: '',
        include: 'sections.items',
    };

    currentAllowedFieldsStatus: { [key: string]: boolean } = {};
    currentAllowedItemsStatus: { [key: string]: boolean } = {};
    canAddItems : boolean = false;
    accordionStates: { [key: string]: boolean } = {};
    isItemsAccordionLocked: boolean = false;

    imageShare: {url?: string, path?: string}|null = {
        url: '',
        path: '',
    };
    image: {url?: string, path?: string}|null = {
        url: '',
        path: '',
    };

    set loadingQueue(value: number) {
        if (this.innerLoadingQueue !== value) {
            this.innerLoadingQueue = value;

            if (this.innerLoadingQueue <= 0) {
                this.innerLoadingQueue = 0;
                this.loading = false;
            } else {
                this.loading = true;
            }
        }
    }
    get loadingQueue(): number {
        return this.innerLoadingQueue;
    }
    get sectionControls(): FormArray {
        return this.form?.get('sections') as FormArray;
    }
    get formFieldControls(): FormArray<FormGroup> {
        return this.form?.get('form_fields') as FormArray;
    }

    formFieldOptions(formFieldIndex: number) : FormArray<FormGroup> {
        return this.formFieldControls?.at(formFieldIndex).get("options") as FormArray
    }

    constructor(
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private franchiseService: FranchiseService,
        private apiValidation: ApiValidation,
        private locationService: Location,
    ) {

    }

    ngOnInit(): void {
        this.franchiseId = this.route.snapshot.paramMap.get('id') as string;
        this.courseId = this.route.snapshot.paramMap.get('courseId') as string;

        this.user = this.authService?.getUser() ?? new User();

        if (!this.user?.can(['admin', 'marketing'])) {
            this.courseId = this.route.snapshot.paramMap.get('id') as string;
            this.franchiseId = (this.user?.franchise?.id ?? '') as string;
        }

        this.getCourse();
        this.initForm();
        this.getDesigns();
        this.sectionTypeOptions = this.getSectionTypeOptions();

        this.form?.get('design')?.valueChanges.subscribe(value => {
            this.updateAllowedFieldsAndItems();
        });

        this.sectionControls.valueChanges.subscribe(() => {
            this.updateAllowedFieldsAndItems();
        });

        this.updateAllowedFieldsAndItems();

    }

    ngOnDestroy(): void {
        this.subscriptions?.map(item => item?.unsubscribe());
        this.listSubscription?.unsubscribe();
    }

    protected initForm() {
        this.form = this.formBuilder.group({
            url: new UntypedFormControl('', [
                Validators.maxLength(255),
                Validators.pattern(/^[\p{L}\p{N}]+(?:-[\p{L}\p{N}]+)*$/u)
            ]),
            title: new UntypedFormControl('', [
                Validators.maxLength(255),
            ]),
            description: new UntypedFormControl('', [
                Validators.maxLength(10000),
            ]),
            image: new UntypedFormControl('', [
                Validators.maxLength(255),
            ]),
            image_share: new UntypedFormControl('', [
                Validators.maxLength(255),
            ]),
            design: new UntypedFormControl(0, [
                ...(this.user?.can(['admin']) ? [
                    Validators.required
                ] : [])
            ]),
            landing_course_category:  new UntypedFormControl('', [
                Validators.maxLength(255),
            ]),
            landing_course_videoclip:  new UntypedFormControl('', [
                Validators.maxLength(65535),
            ]),
            landing_course_additional_text:  new UntypedFormControl('', [
                Validators.maxLength(65535),
            ]),
            landing_course_scripts: new UntypedFormControl('', [
                Validators.maxLength(65535),
            ]),
            landing_course_suitable: new UntypedFormControl('', [
                Validators.maxLength(65535),
            ]),
            landing_course_viber: new UntypedFormControl('', [
                Validators.maxLength(255),
            ]),

            landing_course_without_certificate: new UntypedFormControl(false, [

            ]),
            landing_course_without_exam: new UntypedFormControl(false, [

            ]),
            landing_course_without_video: new UntypedFormControl(false, [

            ]),

            sidebar_options: new UntypedFormControl([], []),

            certificate: new UntypedFormControl(false, []),
            status: new UntypedFormControl(true),
            certificateStatus: new UntypedFormControl(false),
            sections: this.formBuilder.array([]),
            form_fields: this.formBuilder.array([]),
            selectedSection: this.formBuilder.group({
                title: [''],
                subtitle: [''],
                description: [''],
                thumbnail: [''],
                image: [''],
                alt: [''],
                type: [''],
                status: [''],
                position: ['']
            }),
            preferences: this.formBuilder.group({
                courseTitle: new UntypedFormControl(false, []),
                multiplePage: new UntypedFormControl(true, []),

                studentXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                studentYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                studentWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                studentHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                studentFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                studentFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                frontDateXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                frontDateYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                frontDateWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                frontDateHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                frontDateFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),
                frontDateFont: new UntypedFormControl('bahnschrift-semi-condensed', []),

                // second page
                secondCourseTitleXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondCourseTitleYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondCourseTitleWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondCourseTitleHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondCourseTitleFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                secondCourseTitleFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                certificateNumberXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                certificateNumberYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                certificateNumberWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                certificateNumberHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                certificateNumberFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                certificateNumberFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                heldDateNumberXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                heldDateNumberYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                heldDateNumberWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                heldDateNumberHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                heldDateNumberFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                heldDateNumberFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                secondStudentXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondStudentYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondStudentWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondStudentHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondStudentFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                secondStudentFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                secondTopicsXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondTopicsYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondTopicsWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondTopicsHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondTopicsFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
                secondTopicsFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),

                secondDateXCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondDateYCoord: new UntypedFormControl(0, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondDateWidth: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondDateHeight: new UntypedFormControl(160, [Validators.min(0),Validators.max(10000), Validators.pattern('^[0-9]*$')]),
                secondDateFontSize: new UntypedFormControl(16, [Validators.min(0),Validators.max(200)]),
                secondDateFont: new UntypedFormControl('bahnschrift-semi-condensed', []),
            })
        });

        this.form?.get('sidebar_options')?.valueChanges.subscribe(value => {
            this.form?.get('landing_course_without_certificate')?.setValue(value.includes('without_certificate'));
            this.form?.get('landing_course_without_exam')?.setValue(value.includes('without_exam'));
            this.form?.get('landing_course_without_video')?.setValue(value.includes('without_video'));
        });
    }

    createSection(sectionData?: any): FormGroup {
        const sectionGroup = this.formBuilder.group({
            title: [sectionData?.title ?? '', [Validators.min(1), Validators.maxLength(255)]],
            subtitle: [sectionData?.subtitle ?? '', [Validators.min(1), Validators.maxLength(255)]],
            description: [sectionData?.description ?? '', [Validators.min(1), Validators.maxLength(65535)]],
            thumbnail: [sectionData?.thumbnail ?? '', [Validators.min(1), Validators.maxLength(255)]],
            image: [sectionData?.image ?? '', [Validators.min(1), Validators.maxLength(255)]],
            alt: [sectionData?.alt ?? '', [Validators.min(1), Validators.maxLength(255)]],
            type: [sectionData?.type ?? 'header'],
            status: [(sectionData?.status ?? 'active') === 'active', []],
            position: [sectionData?.position ?? 1, [Validators.min(1), Validators.max(2147483647)]],
            items: this.formBuilder.array(sectionData?.items?.map((item:any) => this.createItem(item)) || [])
        });

        sectionGroup.get('type')?.valueChanges.subscribe(type => {
            if (type === 'header' || type === 'footer') {
                sectionGroup.get('title')?.setValue(type.charAt(0).toUpperCase() + type.slice(1));
            }
            else {
                sectionGroup.get('title')?.value === 'Header' || sectionGroup.get('title')?.value === 'Footer' ? sectionGroup.get('title')?.setValue('') : sectionGroup.get('title')?.value;
            }

            if (!this.canAddItems) {
                const items = sectionGroup.get('items') as FormArray;
                items.clear();
            }
        });

        if (sectionData?.type === 'header' || sectionData?.type === 'footer') {
            sectionGroup.get('title')?.setValue(sectionData.type.charAt(0).toUpperCase() + sectionData.type.slice(1));
        }

        sectionGroup.get('type')?.updateValueAndValidity();

        return sectionGroup;
    }

    createItem(itemData?: any): FormGroup {
        return this.formBuilder.group({
            title: [itemData?.title ?? '', [Validators.min(1), Validators.maxLength(255)]],
            subtitle: [itemData?.subtitle ?? '', [Validators.min(1), Validators.maxLength(255)]],
            url: [itemData?.url ?? '', [Validators.maxLength(255)]],
            description: [itemData?.description ?? '', [Validators.min(1), Validators.maxLength(65535)]],
            thumbnail: [itemData?.thumbnail ?? '', [Validators.min(1), Validators.maxLength(255)]],
            image: [itemData?.image ?? '',[Validators.min(1), Validators.maxLength(255)]],
            alt: [itemData?.alt ?? '', [Validators.min(1), Validators.maxLength(255)]],
            status: [(itemData?.status ?? 'active') === 'active', []],
            position: [itemData?.position ?? 1, [Validators.min(1), Validators.max(2147483647)]]
        });
    }

    onSectionAction(action: string): void {
        if (action === 'add' ) {
            this.addSection();
        }
        else if (action === 'copy') {
            this.onCopySectionsFromCourse();
        }
        else if (action === 'export') {
            this.exportAsJson();
        }
    }

    addSection(event?: MouseEvent): void {
        event?.preventDefault();
        const sections = this.form?.get('sections') as FormArray;
        sections.push(this.createSection());
    }

    onCopySectionsFromCourse(event?: MouseEvent): void {
        event?.preventDefault();

        this.franchiseCoursesFilter = {
            q: '',
            page: 1,
            limit: this.PAGINATION_LIMIT,
            include: 'sections.items',
        };
        this.getFranchiseCourses();
        this.showCopySectionsDialog = true;
    }

    protected exportAsJson(): void {
        const data = this.sectionControls?.getRawValue();
        const jsonStr = JSON.stringify(data);
        const blob = new Blob([jsonStr], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = ('' + (this.course?.course?.title || 'file'))?.trim().replace(/\s+/g, '_') || 'file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    protected importFromJson(event?: {id?: string, action: UploadComponentActionName, response: any}) {
        if (event?.action !== 'onFilesFinished' || event?.id !== 'import') {
            return;
        }

        try {
            const data = JSON.parse(event?.response?.files[0]?.response);
            if (typeof data !== 'object') {
                throw new Error('Invalid parsed data.');
            }

            data?.forEach((section: FranchiseCourseSection) => {
                section.status = section.status ? 'active' : 'inactive';

                const sectionGroup = this.createSection(section);
                this.sectionControls.push(sectionGroup);

                const itemsArray = sectionGroup.get('items') as FormArray;
                itemsArray.clear();

                section.items?.forEach(item => {
                    item.status = item.status ? 'active' : 'inactive'

                    const itemGroup = this.createItem(item);
                    itemsArray.push(itemGroup);
                });
            });

        } catch (e) {
            this.messageService.add({
                severity: 'error',
                summary: translate("Невалиден формат, проблем с качването или файлът е прекалено голям: ")
                    + event?.response?.files[0]?.file?.name,
            });
        }
    }

    onFranchiseCourseListMore(additional: {q: string, reset: boolean}): void {
        if (additional.reset) {
            this.franchiseCourses = null;
            this.franchiseCoursesFilter.page = 1;
        }

        this.franchiseCoursesFilter.q = additional.q;
        this.getFranchiseCourses(!additional.reset);
    }

    onSelectSectionsToCopy(selected?: number[]): void {
        this.franchiseCourses?.data
            ?.filter(course => selected?.includes(course.id ?? 0))
            ?.map(course => course.sections)
            ?.flat()
            ?.forEach(section => {
                const sectionGroup = this.createSection({
                    ...section,
                    status: section?.status === 'active'
                });
                this.sectionControls.push(sectionGroup);

                const itemsArray = sectionGroup.get('items') as FormArray;
                itemsArray.clear();

                section?.items?.forEach(item => {
                    const itemGroup = this.createItem({
                        ...item,
                        status: item.status === 'active'
                    });
                    itemsArray.push(itemGroup);
                });
            });
    }

    protected getFranchiseCourses(appendData?: boolean): void {
        if (this.loading) {
            return;
        }

        if (appendData && this.franchiseCourses?.data?.length) {
            if (this.franchiseCourses?.reachEnd()) {
                return;
            }
            this.franchiseCoursesFilter.page = this.franchiseCourses?.nextPage();
        } else if (!this.franchiseCourses?.data?.length) {
            this.franchiseCoursesFilter.page = 1;
        }

        this.loadingQueue++;
        const subscription = this.franchiseService.getCoursesList(this.franchise?.id ?? 0, this.franchiseCoursesFilter).subscribe({
            next: response => {
                this.loadingQueue--;

                if (appendData && this.franchiseCourses) {
                    response.data = [
                        ...this.franchiseCourses?.data ?? [],
                        ...response?.data ?? [],
                    ];
                }

                this.franchiseCourses = response;
                this.franchiseCoursesList = this.franchiseCourses?.data?.map(item => {
                    return {
                        value: item.id,
                        label: item.title ?? item?.course?.title ?? '',
                        description: item.id === this.course?.id
                            ? translate('Текущ курс')
                            : translate('{{n}} налични секции', {n: item.sections?.length}),
                        disabled: item.id === this.course?.id || !item?.sections?.length,
                    } as ModalItemsChooseComponentItem;
                }).slice() ?? [];
            },
            error: error => {
                this.loadingQueue--;

                this.franchiseCoursesList = [];
            }
        });
        this.subscriptions.push(subscription);

    }

    addElement(): void {
        if (this.selectedSectionIndex === null) {
            return;
        }

        const section = (this.form?.get('sections') as FormArray).at(this.selectedSectionIndex) as FormGroup;
        const items = section.get('items') as FormArray;
        items.push(this.createItem());
    }

    selectItem(index: number): void {
        this.selectedItemIndex = index;
    }

    get selectedSectionItems(): FormArray {
        if (this.selectedSectionIndex !== null) {
            const section = this.sectionControls.at(this.selectedSectionIndex) as FormGroup;
            return section.get('items') as FormArray;
        }
        return this.formBuilder.array([]);
    }

    onSubmit(event?: Event): void {
        if (this.loading) {
            return;
        }

        if (this.form?.invalid) {
            this.errors = this.form?.controls;

            this.messageService.add({
                severity: 'error',
                summary: translate('Грешка!'),
                detail: translate('Моля, проверете полетата отново!'),
            });
            this.form?.markAllAsTouched();

            return;
        }

        this.form?.get('image')?.setValue((this.image?.path || '').trim());
        this.form?.get('image_share')?.setValue((this.imageShare?.path || '').trim());

        const formData = this.form?.getRawValue();
        formData.image = this.form?.get('image')?.value || null;
        formData.image_share = this.form?.get('image_share')?.value || null;
        formData.certificateStatus = formData.certificateStatus ? 'active' : 'inactive';
        formData.status = formData.status ? 'active' : 'inactive';
        formData?.sections?.forEach((section: any, sectionIndex: number) => {
            section.position = sectionIndex + 1;
            section.status = section.status ? 'active' : 'inactive';

            section.items.forEach((item: any, itemIndex: number) => {
                item.position = itemIndex + 1;
                item.status = item.status ? 'active' : 'inactive';

                item.thumbnail = item.thumbnail || '';
                item.image = item.image || '';
            });
        });

        formData?.form_fields?.forEach((formField: any, formFieldIndex: number) => {
            formField.position = formFieldIndex + 1;
            formField.required = true;

            formField.options.forEach((option: any, optionIndex: number) => {
                option.position = optionIndex + 1;
            });
        });

        delete formData.landing_course_category;
        delete formData.landing_course_scripts;
        delete formData.landing_course_suitable;
        delete formData.landing_course_videoclip;
        delete formData.landing_course_additional_text;
        delete formData.landing_course_without_certificate;
        delete formData.landing_course_without_exam;
        delete formData.landing_course_without_video;
        delete formData.landing_course_viber;

        let preferenceList: any = this.course?.preferences?.filter((preference: any) => !preference.name?.startsWith('landing.'))?.map(item => {
           item.value = '' + item.value;
            return item;
        });
        formData.preferences = preferenceList;

        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_CATEGORY,
            value: this.form?.get('landing_course_category')?.value,
        });

        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_VIDEOCLIP,
            value: this.form?.get('landing_course_videoclip')?.value,
        });
        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_ADDITIONAL_TEXT,
            value: this.form?.get('landing_course_additional_text')?.value,
        });

        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_SCRIPTS,
            value: this.form?.get('landing_course_scripts')?.value,
        });
        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_SUITABLE,
            value: this.form?.get('landing_course_suitable')?.value,
        });
        formData.preferences.push({
            type: 'boolean',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_CERTIFICATE,
            value: '' + this.form?.get('landing_course_without_certificate')?.value,
        });
        formData.preferences.push({
            type: 'boolean',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_EXAM,
            value: '' + this.form?.get('landing_course_without_exam')?.value,
        });
        formData.preferences.push({
            type: 'boolean',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_VIDEO,
            value: '' + this.form?.get('landing_course_without_video')?.value,
        });
        formData.preferences.push({
            type: 'string',
            visibility: 'public',
            name: FranchisePreference.PREFERENCE_LANDING_COURSE_VIBER,
            value: this.form?.get('landing_course_viber')?.value,
        });

        if (formData['selectedSection']) {
            delete formData['selectedSection'];
        }

        this.loadingQueue++;
        const subscription = this.franchiseService.updateCourse(+(this.franchiseId ?? 0), +(this.courseId ?? 0), formData).subscribe({
            next: response => {
                this.loadingQueue--;

                this.messageService.add({
                    severity: 'success',
                    summary: translate('Успешно!'),
                    detail: translate('Успешно редактиран курс!'),
                });

                this.getCourse();
            },
            error: (error: any) => {
                this.loadingQueue--;
                this.apiValidation.checkBadRequest(error, this.form).then((data: any) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: translate('Грешка!'),
                        detail: data.message
                    });
                    this.errors = data.errors;
                });
            }
        });
        this.subscriptions.push(subscription);
    }

    protected getCourse(): void {
        const subscription = this.franchiseService.getCourse(+(this.franchiseId ?? 0), +(this.courseId ?? 0)).subscribe({
            next: response => {

                this.course = response.data;
                this.franchise = this.course?.franchise ?? this.franchise;

                if (this.user?.role?.name === 'partner') {
                    this.design = response.data?.design ?? null;
                }

                this.form?.patchValue({
                    url: this.course.url,
                    description: this.course.description,
                    image: this.course.image,
                    image_share: this.course.image_share,
                    title: this.course.title,
                    design: this?.user?.role?.name === 'admin' ? this.course?.design?.id : null,
                    status: this.course.status === 'active',
                    certificate: false,
                    landing_course_category: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_CATEGORY)?.value?.toString() ?? '',
                    landing_course_videoclip: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_VIDEOCLIP)?.value?.toString() ?? '',
                    landing_course_additional_text: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_ADDITIONAL_TEXT)?.value?.toString() ?? '',
                    landing_course_scripts: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_SCRIPTS)?.value?.toString() ?? '',
                    landing_course_suitable: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_SUITABLE)?.value?.toString() ?? '',
                    landing_course_without_certificate: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_CERTIFICATE)?.value ?? false,
                    landing_course_without_exam: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_EXAM)?.value ?? false,
                    landing_course_without_video: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_VIDEO)?.value ?? false,
                    landing_course_viber: this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_VIBER)?.value?.toString() ?? '',
                    sidebar_options: [
                        this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_CERTIFICATE)?.value ? 'without_certificate' : '',
                        this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_EXAM)?.value ? 'without_exam' : '',
                        this.course?.getPreference(FranchisePreference.PREFERENCE_LANDING_COURSE_WITHOUT_VIDEO)?.value ? 'without_video' : '',
                    ].filter(item => item),
                });

                this.imageShare = {
                    url: (this.course.image_share || ''),
                    path: (this.course.image_share || ''),
                };

                this.image = {
                    url: (this.course.image || ''),
                    path: (this.course.image || ''),
                };

                this.sectionControls?.clear();
                this.course?.sections?.forEach(section => {
                    const sectionGroup = this.createSection({
                        ...section,
                        status: section.status
                    });
                    this.sectionControls.push(sectionGroup);

                    const itemsArray = sectionGroup.get('items') as FormArray;
                    itemsArray.clear();

                    section.items?.forEach(item => {
                        const itemGroup = this.createItem({
                            ...item,
                            status: item.status
                        });
                        itemsArray.push(itemGroup);
                    });
                });

                this.formFieldControls?.clear();
                this.course?.form_fields?.forEach(formField => {
                    formField
                    const formFieldGroup = this.formFieldCreate({
                        ...formField,
                        type: 'option',
                        status: formField.status,
                    });
                    this.formFieldControls.push(formFieldGroup);

                    const itemsArray = formFieldGroup.get('options') as FormArray;
                    itemsArray.clear();

                    formField.options?.forEach(item => {
                        const itemGroup = this.formFieldCreateOption({
                            ...item,
                            status: item.status
                        });
                        itemsArray.push(itemGroup);
                    });
                });
            },
            error: error => {
                this.messageService.add({
                    severity: 'error',
                    summary: translate('Курсът не е намерен.'),
                });
                this.locationService.back();
            }
        });
        this.subscriptions.push(subscription);
    }

    protected getDesigns() {
        this.loadingQueue++;

        const subscription = this.franchiseService.getCourseDesigns().subscribe({
            next: data => {
                this.loadingQueue--;
                this.optionsDesign = data?.data;
            },
            error: error => {
                this.loadingQueue--;

                this.messageService.add({
                    severity: 'error',
                    summary: translate('Грешка при извличането на курсове!'),
                });
            }
        });
        this.subscriptions.push(subscription);
    }

    drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.sectionControls.controls, event.previousIndex, event.currentIndex);
        const sections = this.form?.get('sections')
        if(sections) {
            sections.setValue(this.sectionControls.controls.map(control => control.value));
        }

        this.selectSection(event.currentIndex);
    }

    selectSection(index: number): void {
        this.selectedSectionIndex = index;
        this.updateAllowedFieldsAndItems();
        this.accordionStates = {};
        this.isItemsAccordionLocked = false;
    }

    get selectedSectionFormGroup(): FormGroup {
        return this.sectionControls.at(this.selectedSectionIndex ?? 0) as FormGroup;
    }

    addItem(): void {
        if (this.selectedSectionIndex === null || !this.canAddItems) {
            return;
        }

        const items = this.selectedSectionItems;
        items.push(this.createItem());
    }

    dropItem(event: CdkDragDrop<any[]>): void {
        if (this.selectedSectionIndex !== null) {
            const items = this.selectedSectionItems;
            moveItemInArray(items.controls, event.previousIndex, event.currentIndex);
            items.setValue(items.controls.map(control => control.value));
        }
    }

    getFormGroupAtIndex(index: number): FormGroup {
        return this.selectedSectionItems.at(index) as FormGroup;
    }

    removeSection(event: Event, index: number): boolean {
        event?.stopPropagation();

        this.sectionControls.removeAt(index);
        this.selectedSectionIndex = this.selectedSectionIndex === index ? null : this.selectedSectionIndex;

        return false;
    }

    removeItem(index: number): void {
        this.selectedSectionItems.removeAt(index);
    }

    onFileFinished(event: { files: UploadComponentQueueType<UploadModel>[] }, isThumbnail: boolean, sectionIndex: number, itemIndex?: number): void {
        if (!event.files || !event.files.length || event.files[0].error) {
            this.message = translate('Невалидна снимка, или файлът е твърде голям.');
            this.messageType = 'error';
            return;
        }

        const fileData = {
            path: event.files[0].response.data.path,
            url: event.files[0].response.data.url,
        };

        if (typeof itemIndex === 'number') {
            // It's an item upload
            const itemFormGroup = (this.sectionControls.at(sectionIndex) as FormGroup).get('items') as FormArray;
            const itemControl = itemFormGroup.at(itemIndex) as FormGroup;
            itemControl.get(isThumbnail ? 'thumbnail' : 'image')?.setValue(fileData.url);
        } else {
            // It's a section upload
            const sectionFormGroup = this.sectionControls.at(sectionIndex) as FormGroup;
            sectionFormGroup.get(isThumbnail ? 'thumbnail' : 'image')?.setValue(fileData.url);
        }
    }

    onImageShareFinished({files}: {files: UploadComponentQueueType<UploadModel>[]}): void {
        if (!files || !files.length || files[0].error) {
            this.message = translate('Невалидна снимка, или файлът е твърде голям.');
            this.messageType = 'error';
        } else {
            this.imageShare = {
                path: files[0].response.data.path,
                url: files[0].response.data.url,
            };
        }
    }

    onImageFinished({files}: {files: UploadComponentQueueType<UploadModel>[]}): void {
        if (!files || !files.length || files[0].error) {
            this.message = translate('Невалидна снимка, или файлът е твърде голям.');
            this.messageType = 'error';
        } else {
            this.image = {
                path: files[0].response.data.path,
                url: files[0].response.data.url,
            };
        }
    }

    getPhotoUrl(isThumbnail: boolean, sectionIndex: number, itemIndex?: number): string {
        const section = this.sectionControls.at(sectionIndex) as FormGroup;
        if (typeof itemIndex === 'number') {
            const item = (section.get('items') as FormArray).at(itemIndex) as FormGroup;
            return item.get(isThumbnail ? 'thumbnail' : 'image')?.value;
        } else {
            return section.get(isThumbnail ? 'thumbnail' : 'image')?.value;
        }
    }

    removeFile(isThumbnail: boolean, sectionIndex: number, itemIndex?: number): void {
        const section = this.sectionControls.at(sectionIndex) as FormGroup;
        if (typeof itemIndex === 'number') {
            const item = (section.get('items') as FormArray).at(itemIndex) as FormGroup;
            item.get(isThumbnail ? 'thumbnail' : 'image')?.setValue('');
        } else {
            section.get(isThumbnail ? 'thumbnail' : 'image')?.setValue('');
        }
    }

    getSectionTypeOptions(): {label: string, value: string}[] {
        return Object.keys(SectionType).map((key, index) => {
            return {
                label: this.SECTION_NAMES[key.toLowerCase()],
                type: key.charAt(0).toUpperCase() + key.slice(1),
                value: SectionType[key as keyof typeof SectionType]
            };
        });
    }

    private updateAllowedFieldsAndItems(): void {
        const designId = this.design?.name ?? this.form?.get('design')?.value;

        this.currentAllowedFieldsStatus = {};
        this.currentAllowedItemsStatus = {};
        this.canAddItems = false;

        const allPossibleFields = ['title', 'subtitle', 'description', 'thumbnail', 'image', 'alt'];
        const allPossibleItems = ['title', 'subtitle', 'url', 'description', 'image', 'alt', 'subscription'];

        allPossibleFields.forEach(field => {
            this.currentAllowedFieldsStatus[field] = true;
        });

        allPossibleItems.forEach(item => {
            this.currentAllowedItemsStatus[item] = true;
        });

        this.canAddItems = allPossibleItems.length > 0;
    }

    getSectionTitleDisplay(sectionType: string, index: number): string {
        const capitalizedType = sectionType.charAt(0).toUpperCase() + sectionType.slice(1);
        const sectionsOfType = this.sectionControls.controls.map(ctrl => ctrl.get('type')?.value);
        const typeCount = sectionsOfType.slice(0, index).filter(type => type === sectionType).length;

        return typeCount > 0 ? `${capitalizedType} ${typeCount + 1}` : capitalizedType;
    }

    getItemTitleDisplay(index: number): string {
        return `Item ${index + 1}`;
    }

    toggleAccordionState(position: number): void {
        this.accordionStates[position] = !this.accordionStates[position];

        this.isItemsAccordionLocked = Object.values(this.accordionStates).some(state => state);
    }

    onFormFieldAction(action: string): void {
        if (action === 'add' ) {
            this.formFieldAdd();
        }
    }

    formFieldAdd(event?: MouseEvent): void {
        event?.preventDefault();
        const form_fields = this.form?.get('form_fields') as FormArray;
        form_fields.push(this.formFieldCreate());
    }

    formFieldCreate(formFields?: FranchiseCourseFormField): FormGroup {
        const formFieldGroup = this.formBuilder.group({
            name: [formFields?.name ?? '', [Validators.required, Validators.maxLength(255)]],
            label: [formFields?.label ?? '', [Validators.maxLength(255)]],
            type: [formFields?.type ?? 'option'],
            status: [formFields?.status ?? 'active'],
            position: [formFields?.position ?? 1, [Validators.min(1), Validators.max(2147483647)]],
            options: this.formBuilder.array(formFields?.options?.map((item:any) => this.formFieldCreateOption(item)) || [])
        });

        return formFieldGroup;
    }

    formFieldRemove(formFieldIndex: number): void {
        this.formFieldControls.removeAt(formFieldIndex);
    }

    formFieldRemoveOption(formFieldIndex: number, formFieldOptionIndex: number ): void {
        const options = this.formFieldControls.at(formFieldIndex).get('options') as FormArray;
        options.removeAt(formFieldOptionIndex);
    }

    formFieldAddOption(formFieldIndex: number): void {
        (this.formFieldControls?.at(formFieldIndex)?.get('options') as FormArray)?.push(this.formFieldCreateOption());
    }

    formFieldCreateOption(itemData?: FranchiseCourseFormFieldOption): FormGroup {
        return this.formBuilder.group({
            value: [itemData?.value ?? '', [Validators.required, Validators.maxLength(255)]],
            label: [itemData?.label ?? '', [Validators.maxLength(255)]],
            placeholder: [itemData?.placeholder ?? '', [Validators.maxLength(255)]],
            status: [itemData?.status ?? 'active'],
            position: [itemData?.position ?? 1, [Validators.min(1), Validators.max(2147483647)]]
        });
    }
}
